/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import axios from 'axios';
import { graphql, useStaticQuery } from 'gatsby';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';

import i18n from '../../i18n';
import Chat from '../components/chat';
import EmailCapture from '../components/email-capture';
import Footer from '../components/footer';
import Header from '../components/header/index';
import Share from '../components/share';
// import WelcomeModal from '../components/welcome-modal';
import favicon from '../images/favicon.ico';
import { getEmailSubsribe } from '../services/email-capture';
import theme from '../theme/index';

const isEmailSubscribeCookies = getEmailSubsribe();

const GATSBY_APP_API_URL = process.env.GATSBY_APP_API_URL;

const useStyles = makeStyles({
  '@global': {
    body: {
      height: '100%'
    },
    html: {
      height: '100%'
    },
    '#___gatsby': {
      height: '100%'
    },
    'h1, h2, h3, h4, h5, h6': {
      margin: 0
    },
    p: {
      margin: 0
    },
    '#apps-block>.MuiGrid-spacing-xs-3': {
      width: '100%'
    }
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh'
  },
  main: {
    flex: '1 0 auto',
    overflow: 'hidden',
    backgroundColor: '#fff'
  }
});

/**
 * @todo move to API client
 */
axios.defaults.baseURL =
  process.env.NODE_ENV === 'production'
    ? process.env.GATSBY_APP_API_URL
    : '/api';

const Layout = ({ children }) => {
  const classes = useStyles();
  const [user, setUser] = React.useState(null);
  const [isAuthenticated, setAuthenticated] = React.useState(false);

  const [isEmailSubscribeVisible, setIsEmailSubscribeVisible] = React.useState(
    true
  );

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          twitterHandle
          url
        }
      }
    }
  `);

  React.useEffect(() => {
    const token = Cookies.get('token');
    setAuthenticated(!!Cookies.get('token')); // @todo move to useState()

    // const token = localStorage.getItem('token');
    // setAuthenticated(!!localStorage.getItem('token')); 
    if (token) {
      axios
        .get(GATSBY_APP_API_URL+`/user/me`, {
          headers: {
            'x-authorization': `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*"
          },
          mode: 'cors'
        })
        .then(response => {
          if (response.data && response.data.success === true) {
            setUser(response.data.user);
          }
        })
        .catch(error => {
          console.log("error during the get the user information from the token: ", error);
        });
    }
  }, []);

  const handleClose = () => {
    Cookies.set('email_subscribe', '1');
    return setIsEmailSubscribeVisible(false);
  };

  return (
    <>
      <Helmet>
        <link rel="icon" href={favicon} />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800|Roboto:300,400,500&display=swap"
        />
      </Helmet>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className={classes.root}>
          <Header
            siteTitle={data.site.siteMetadata.title}
            // user={user}
            isAuthenticated={isAuthenticated}
          />
          <main className={classes.main}>{children}</main>
          <Footer siteTitle={data.site.siteMetadata.title} />
          <Share
            socialConfig={{
              twitterHandle: data.site.siteMetadata.twitterHandle,
              config: {
                url: `${data.site.siteMetadata.url}`,
                title: data.site.siteMetadata.title
              }
            }}
          />
        </div>
        <div className="email-capture">
          {!isEmailSubscribeCookies && isEmailSubscribeVisible && (
            <EmailCapture onCancel={handleClose} />
          )}
        </div>

        <Chat />
        {/* <WelcomeModal /> */}
      </ThemeProvider>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
